import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import styles from '../index.module.css'
import { Layer, Logo } from 'components'
import { useRecoilState } from 'recoil'
import { showDetailLayerState } from './states'
import Lib from 'library';

const ReceiptDetailLayer = () => {

	const App = useApp()
	const [layer, setLayer] = useRecoilState(showDetailLayerState)
	const [data, setData] = useState({})

	const getData = () => {
		if (!layer || !layer.id) return
		Lib.get(`/api/more/data/rcpt/${layer.id}`, data => {
			layer.show && setData(data)
		})
	}

	useEffect(() => {
		if (layer.show) {
			getData()
		} else {
			setData()
		}
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [layer.show])

	return (
		<Layer show={layer.show} closeLayer={() => setLayer({
			show: false,
			id: layer.id
		})}>
			<div className="page">
				{data ?
					<>
						<div className="shadow">
							<div className="padding">
								<div className={styles["manage-title"]}>데이터 영수증 상세</div>
								<div className="flex-align_center mt_20">
									<div className="img-box img-symbol img-symbol-lg">
										<Logo code={data.insttCd} style={{ width: "100%", height: "100%" }} />
									</div>
									<div className={`${styles["manage-title"]} ml_10`}>{data.insttNm}</div>
								</div>
								<hr className="my_30" />
								<ul className="list-item" style={{ fontSize: "1.4rem" }}>
									<li>
										<span>영수증 유형</span>
										<span>{data.rcptTpNm}</span>
									</li>
									<li>
										<span>영수증 일시</span>
										<span>{data.useDt}</span>
									</li>
									<li>
										<span>영수증 ID</span>
										<span>{data.rcptId}</span>
									</li>
								</ul>
							</div>
						</div>
						<div className="padding">
							<ul className="list-item block" style={{ fontSize: "1.4rem" }}>
								<li>
									<span>정보제공자</span>
									<span>{data.insttNm}</span>
								</li>
								<li>
									<span>개인(신용)정보를 제공받는 자</span>
									<span>{App.comName}</span>
								</li>
								<li>
									<span>전송요구 및 수집∙이용목적</span>
									<span>전송요구를 통한 본인신용정보 통합조회, 데이터 분석 서비스의 이용</span>
								</li>
								<li>
									<span>전송을 요구하는 개인신용정보의 보유∙이용기간</span>
									<span>서비스 이용 종료시 또는 삭제 요구시 까지</span>
								</li>
								<li>
									<span>정기적전송여부</span>
									<span>{data.rglrTrnspYn === "Y" ? "정기적전송(주1회)" : "아니오"}</span>
								</li>
								<li>
									<span>전송요구 종료시점</span>
									<span>{Lib.dateFormat(data.lnkupEdDe, ".")}까지</span>
								</li>
								<li className="mb_20">
									{
										(data.indstCd === "bank" || data.indstCd === "card" || data.indstCd === "efin" || data.indstCd === "pcard" || data.indstCd === "invest") &&
										<span>선택항목</span>
									}
									{(data.indstCd === "bank" || data.indstCd === "efin" || data.indstCd === "invest") && <span className="normal">적요 및 거래메모 정보∙수집 {
										data.tradeMemoAgreeYn === "Y" ? "동의" : "미동의"
									}</span>}
									{(data.indstCd === "card" || data.indstCd === "efin" || data.indstCd === "pcard") && <span className="normal">가맹점명 및 사업자등록번호 정보 {
										data.mbbsNmInfAgreeYn === "Y" ? "동의" : "미동의"
									}</span>}
									{data.indstCd === "efin" && <span className="normal">상품구매 카테고리 정보 {
										data.prodBuyInfAgreeYn === "Y" ? "동의" : "미동의"
									}</span>}
								</li>
								{
									(data.useDtlDataList && data.useDtlDataList.length > 0) &&
									<li>
										<span>수집∙이용 항목</span>
										<span>
											{
												data.useDtlDataList.map((item, index) => {
													return (
														<span key={index} className="block" style={{ color: "#333" }}>{item.infNm} ({item.infId})</span>
													)
												})
											}
										</span>
									</li>
								}
							</ul>
						</div>
					</>
					:
					<>
						<div className="shadow">
							<div className="padding">
								<div className="skeleton" style={{ width: "15rem" }}></div>
								<div className="flex-align_center mt_20">
									<div className="skeleton" style={{ borderRadius: "50%", width: "5.8rem", height: "5.8rem" }} />
									<div className="skeleton ml_15" style={{ width: "12rem" }} />
								</div>
								<hr className="my_30" />
								<ul className="list-item" style={{ fontSize: "1.4rem" }}>
									<li>
										<span className="skeleton" style={{ width: "9rem" }} />
										<span className="skeleton" style={{ width: "9rem" }} />
									</li>
									<li>
										<span className="skeleton" style={{ width: "10rem" }} />
										<span className="skeleton" style={{ width: "8rem" }} />
									</li>
									<li>
										<span className="skeleton" style={{ width: "7rem" }} />
										<span className="skeleton" style={{ width: "12rem" }} />
									</li>
								</ul>
							</div>
						</div>
						<div className="padding">
							<ul className="list-item block">
								<li>
									<span className="skeleton" style={{ width: "9rem" }} />
									<span className="skeleton" style={{ width: "16rem" }} />
								</li>
								<li>
									<span className="skeleton" style={{ width: "9rem" }} />
									<span className="skeleton" style={{ width: "14rem" }} />
								</li>
								<li>
									<span className="skeleton" style={{ width: "10rem" }} />
									<span className="skeleton" style={{ width: "24rem" }} />
								</li>
							</ul>
						</div>
					</>
				}
			</div>
		</Layer>
	)
}

export default ReceiptDetailLayer